// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"FormCheckbox_checkbox__zAl12"};